<div class="loader-overlay" *ngIf="isLoading$ | async">
  <div class="loader-content">
    <div class="spinner"></div>
    <div class="loader-message" *ngIf="message$ | async as message">
      {{ message }}
    </div>
  </div>
</div>
